import {useNavigate} from 'react-router-dom';
import {useState} from 'react';

import LoginHeader from "./components/header";
import LoginMain from "./components/main";
import Footer from '../../generals-components/footer/footer';

function LoginPage() {
    const navigate = useNavigate();
    const [showAlertOK, setShowAlertOK] = useState(false)
    const [OKAlertText, setOKAlertText] = useState("")

    const [showAlertERROR, setShowAlertERROR] = useState(false)
    const [ERRORAlertText, setERRORAlertText] = useState("")

    const showAlert = (type, text) => {
        if (type === "error") {
            setShowAlertERROR(true)
            setERRORAlertText(text)

            setTimeout(function() {
                setShowAlertERROR(false)
            }, 3500)
        }
    }

    const handleLogin = async (dati) => {
        const response = await fetch('/api/login', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify(dati),
        });

        const data = await response.json();

        if (response.ok) {
            if (data.status === "1") {
                setShowAlertOK(true)
                setOKAlertText("Logged as " + dati.email + ", redirecting")
                
                setTimeout(function() {
                    navigate('/');
                }, 2500)
            } else {
                navigate('/two-factor-auth?token=' + data.token)
            }
        } else {
            showAlert("error", data.detail.msg)
        }
    };

    return (
        <>
            <div className="relative flex min-h-screen w-full flex-col overflow-x-hidden">
                <LoginHeader/>
                <LoginMain onLoginSubmit={handleLogin}/>
                <Footer/>
            </div>

            {showAlertOK && <span className="flex px-5 py-2 rounded-xl fixed z-[999] bg-alert-green text-sm right-[10px] top-[10px] select-none animate-[show-alert_3s_ease-in-out_forwards]">{OKAlertText}</span>}
            {showAlertERROR && <span className="flex px-5 py-2 rounded-xl fixed z-[999] bg-alert-red text-sm right-[10px] top-[10px] select-none animate-[show-alert_3s_ease-in-out_forwards]">{ERRORAlertText}</span>}
        </>
    );
}


export default LoginPage;